// reducers/userReducer.js

const storedUserData = localStorage.getItem('userData');
const sAuthToken = localStorage.getItem('sAuthToken');
let parsedUserData = null;

try {
  parsedUserData = JSON.parse(storedUserData);
} catch (error) {
  console.error('Error parsing JSON from local storage:', error);
}

const initialState = {
  user: parsedUserData || null,
  token: sAuthToken || null,   // <- add fallback null for safety
  baseUrl: 'http://healthivadev.eastus.cloudapp.azure.com',
  filterTableDetails: [],
  rejectedClaim: [],
  deniedClaim: [],
  expiredClaim: [],
  errorClaim: [],
  closedClaim: [],
  submissionClaim: [],
  claimId: null,
  demoDetails: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_USER':
      localStorage.setItem('userData', JSON.stringify(action.payload));
      return { ...state, user: action.payload };

    case 'SET_ID':
      return { ...state, claimId: action.payload };

    case 'SET_BASE_URL':
      return { ...state, baseUrl: action.payload };

    case 'SET_DEMODATA':
      return { ...state, demoDetails: action.payload };

    case 'CLEAR_DEMODATA':
      return { ...state, demoDetails: [] }; // <- better to reset as [] not null

    case 'SET_FILTERED_TABLE_DETAILS':
      return { ...state, filterTableDetails: action.payload };

    case 'SET_REJECTED_TABLE':
      return { ...state, rejectedClaim: action.payload };

    case 'SET_DENIED_TABLE':
      return { ...state, deniedClaim: action.payload };

    case 'SET_EXPIRED_TABLE':
      return { ...state, expiredClaim: action.payload };

    case 'SET_ERROR_TABLE':
      return { ...state, errorClaim: action.payload };

    case 'SET_CLOSED_TABLE':
      return { ...state, closedClaim: action.payload };

    case 'SET_SUBMISSION_TABLE':
      return { ...state, submissionClaim: action.payload };

    case 'SET_AUTHTOKEN':
      localStorage.setItem('sAuthToken', action.payload);
      return { ...state, token: action.payload };

    default:
      return state;
  }
};

export default userReducer;
